import { Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
interface CategoryCreateEditSkeletonProps {
  isEdit?: boolean;
}

export const CategoryCreateEditSkeleton: FC<CategoryCreateEditSkeletonProps> = ({ isEdit = false }) => {
  return (
    <Page back insetEnabled={false}>
      <Stack alignItems="center" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
        <Text>{isEdit ? 'Edit Category' : 'Create Category'}</Text>
      </Stack>
      <Stack 
        height="100%" 
        paddingTop="10px" 
        paddingLeft="10px" 
        paddingRight="10px" 
        rowGap="15px"
      >
        <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
          <ThemedSkeleton variant="rectangular" width={60} height={60} sx={{ borderRadius: 2 }} />
        </Stack>
        
        <ThemedSkeleton variant="rectangular" width="100%" height={30} sx={{ borderRadius: 1 }} />
        
        <ThemedSkeleton variant="rectangular" width="100%" height={30} sx={{ borderRadius: 1 }} />
        
        <ThemedSkeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 1 }} />
        
        <ThemedSkeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 1 }} />
        
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" gap={3}>
          <ThemedSkeleton variant="rectangular" width="50%" height={40} sx={{ borderRadius: 1 }} />
          <ThemedSkeleton variant="rectangular" width="50%" height={40} sx={{ borderRadius: 1 }} />
        </Stack>
      </Stack>
    </Page>
  );
};

